<div class="container-fluid p-0">
    <div class="row">
        <div class="col-12">
            <div class="login-card login-dark">
                <div>
                    <div>
                        <a class="logo" [routerLink]="['/home']">
                            <img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="loginPage">
                            <img class="img-fluid for-dark" src="assets/images/logo/logo.png" alt="loginPage">
                        </a>
                    </div>
                    <div class="login-main">
                        <form class="theme-form" ngNativeValidate [formGroup]="form" (submit)="resetPassword()">
                            <h4>Create Your New Password</h4>
                            <div class="form-group">
                                <label class="col-form-label">Old Password</label>
                                <div class="form-input position-relative">
                                    <input class="form-control" type="password" formControlName="oldPassword"
                                        [type]="oldShow ? 'text' : 'password'" name="password" required=""
                                        placeholder="*********">
                                    <div class="show-hide"><span (click)="oldShow = !oldShow"
                                            [class.show]="oldShow"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">New Password</label>
                                <div class="form-input position-relative">
                                    <input class="form-control" type="password" formControlName="password"
                                        [type]="show ? 'text' : 'password'" name="password" required=""
                                        placeholder="*********">
                                    <div class="show-hide"><span (click)="show = !show" [class.show]="show"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-form-label">Retype Password</label>
                                <div class="form-input position-relative">
                                    <input class="form-control" type="password" formControlName="confirmPassword"
                                        [type]="showConfirm ? 'text' : 'password'" name="confirmPassword" required=""
                                        placeholder="*********">
                                    <div class="show-hide"><span (click)="showConfirm = !showConfirm"
                                            [class.show]="showConfirm"></span></div>
                                </div>

                            </div>
                            <div class="form-group mb-0">
                                <br>
                                <button class="btn btn-primary btn-block w-100" type="submit">Create Password</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>